import { Slider as SliderPrimitive } from '@base-ui/react/slider'

import { cn } from '@/lib/utils'

export type SliderProps = {
  label: string
  value: number
  onValueChange: (value: number) => void
  onValueCommitted?: (value: number) => void
  formatValue?: (value: number) => string
  min?: number
  max?: number
  step?: number
  disabled?: boolean
  className?: string
}

function Slider({
  label,
  value,
  onValueChange,
  onValueCommitted,
  formatValue = String,
  min = 0,
  max = 100,
  step = 1,
  disabled,
  className,
}: SliderProps) {
  return (
    <SliderPrimitive.Root
      data-slot="slider"
      value={value}
      onValueChange={onValueChange}
      onValueCommitted={onValueCommitted}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      className={cn('flex w-full touch-none items-center', className)}
    >
      <SliderPrimitive.Control
        data-slot="slider-control"
        className="flex w-full touch-none items-center py-2"
      >
        <SliderPrimitive.Track
          data-slot="slider-track"
          className="bg-muted relative h-1.5 w-full rounded-full"
        >
          <SliderPrimitive.Indicator
            data-slot="slider-indicator"
            className="bg-primary rounded-full"
          />
          <SliderPrimitive.Thumb
            data-slot="slider-thumb"
            getAriaLabel={() => label}
            getAriaValueText={(_formatted, nextValue) => formatValue(nextValue)}
            className="border-primary bg-background ring-background focus-visible:ring-ring block size-4 rounded-full border-2 shadow-sm outline-none ring-2 focus-visible:ring-2"
          />
        </SliderPrimitive.Track>
      </SliderPrimitive.Control>
    </SliderPrimitive.Root>
  )
}

export { Slider }
